import { create } from 'zustand';
import _cloneDeep from 'lodash/cloneDeep';

interface AppStoreValues {
  isLoading: boolean;
  loadingText?: string;
  isSavingProgress: boolean;
}

interface AppState extends AppStoreValues {
  setIsLoading: (isLoading: boolean, loadingText?: string) => void;
  setIsSavingProgress: (isSavingProgress: boolean) => void;
}

const defaults: AppStoreValues = {
  isLoading: false,
  loadingText: '',
  isSavingProgress: false,
};

export const useApp = create<AppState>((set) => ({
  ..._cloneDeep(defaults),
  setIsLoading: (isLoading: boolean, loadingText?: string) => {
    set({ isLoading, loadingText: isLoading ? loadingText : '' });
  },
  setIsSavingProgress: (isSavingProgress: boolean) => set({ isSavingProgress }),
}));
